export function extractType(input: string | undefined): string {
    if (input === undefined) return ' ';
    const parts = input.split('-');
    if (parts.length >= 3) {
        return parts[2];
    }
    return '';
}

export function extractScreen(input: string | undefined): string {
    if (input === undefined) return '';
    const parts = input.split('-');
    return parts[1];
}

// The element id convention is 'screen-<name>-screen' or 'modal-<name>-modal',
// and only the middle segment was ever kept — so 'screen-login' and
// 'modal-login' both recorded as 'login' and a full screen was indistinguishable
// from a modal. The prefix is the surface.
export function extractSurface(input: string | undefined): 'screen' | 'modal' | undefined {
    if (input === undefined) return undefined;
    const prefix = input.split('-')[0];
    if (prefix === 'screen' || prefix === 'modal') return prefix;
    return undefined;
}

export function extractLastWord(input: string | undefined): string {
    if (input === undefined) return '';
    const lastHyphenIndex = input.lastIndexOf('-');
    const lastWord = input.slice(lastHyphenIndex + 1);
    const words = lastWord.split(/(?=[A-Z])/);
    const transformedWords = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
    return transformedWords.join(' ');
}
